import { render, staticRenderFns } from "./KitchenEquipment.vue?vue&type=template&id=9f65145a&"
import script from "./KitchenEquipment.vue?vue&type=script&lang=js&"
export * from "./KitchenEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports